export const blockIconsImagePhotoLibrary = (
	<span className='material-symbols-outlined'>photo_library</span>
);
